export default "__VITE_ASSET__DvDmiWRn__"